import "../../App.css";
import Sidebar from "../../components/Sidebar";
import "../../styles/login.css";
import { withRouter } from "react-router-dom";
import React, { useEffect, useState } from "react";
import DualListBox from "react-dual-listbox";
import "react-dual-listbox/lib/react-dual-listbox.css";
import Parametros from "../Parametros";
import UserTab from "../UserTab";
import CurrentUser from "../CurrentUser";
function AsignacionPerfiles(props) {
  // eslint-disable-next-line
  const { history } = props;
  const [opciones, setOpciones] = useState([]);
  // eslint-disable-next-line
  const [usuario, setUsuario] = useState(CurrentUser.user);
  // eslint-disable-next-line
  const [usuarioAsignado, setUsuarioAsignado] = useState({});
  const [update, setUpdate] = useState(false);
  // eslint-disable-next-line
  const [formularioUpdate, setformularioUpdate] = useState({});
  const [clients, setClients] = useState([]);
  const [units, setUnits] = useState([]);

  useEffect(() => {
    if (!props.location?.state?.mail) {
      history.push("/Usuarios");
    }
  }, [props.location?.state?.mail]);

  useEffect(() => {
    fetch(Parametros.urlApi + "clients", {
      method: "GET",
      headers: {
        Authorization: "Bearer " + usuario.key,
        Accept: "application/json",
        "Content-Type": "application/json",
        Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
      },
    })
      .then((res) => res.json())
      .then((data) => setClients(data));
    fetch(Parametros.urlApi + "units", {
      method: "GET",
      headers: {
        Authorization: "Bearer " + usuario.key,
        Accept: "application/json",
        "Content-Type": "application/json",
        Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
      },
    })
      .then((res) => res.json())
      .then((data) => setUnits(data));
  }, [usuario.key]);

  useEffect(() => {
    fetch(
      Parametros.urlApi + "users/info?email=" + props.location?.state?.mail,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
          Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
        },
      }
    )
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          return response.json();
        } else if (response.status === Parametros.loginTokenExcept) {
          alert(Parametros.loginTokenExceptMessage);
          history.push({
            pathname: "/",
          });
        }
      })
      .then((data) => {
        setUsuarioAsignado(data);
      });
  }, [update, usuario.key, props.location?.state?.mail]);

  useEffect(() => {
    async function llamadaApi() {
      try {
        let responsePerfil = await fetch(
          Parametros.urlApi + "profiles?skip=0&limit=100",
          {
            headers: {
              Authorization: "Bearer " + usuario.key,
              Accept: "application/json",
              "Content-Type": "application/json",
              Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
            },
          }
        );
        if (!responsePerfil.ok) throw new Error("Error al cargar perfiles");
        let responsePerfilJson = await responsePerfil.json();
        setOpciones(responsePerfilJson);
      } catch (error) {
        console.error(error);
      }
    }
    llamadaApi();
  }, [usuario.key]);

  let onchangeFullCompanies = async (value) => {
    let form = {
      show_all_companies: !usuarioAsignado.show_all_companies,
      email: usuarioAsignado.mail,
    };

    if (window.confirm("¿Esta seguro que deseas actualizar este elemento?")) {
      let response = await fetch(Parametros.urlApi + "user/config", {
        method: "PUT",
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
          Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
        },
        body: JSON.stringify(form),
      });
      let responseJson = await response.json();

      if (
        response.status === 200 ||
        response.status === 201 ||
        response.status === 201
      ) {
        alert(
          "Actualización completada. Recuerde que el usuario editado debe volver a loguearse para reflejar los cambios."
        );
        setUpdate(!update);
      } else {
        alert("Error al Actualizar");
      }
    }
  };

  let formatAccion = (item) => {
    if (item) {
      let newList = [];
      item.map((perfil) => {
        return newList.push(perfil.profile_id);
      });
      return newList;
    } else {
      return [];
    }
  };

  let formAcreedor = (item) => {
    let newList = [];
    if (item) {
      item.map((acreedor) => {
        newList.push(acreedor.person_uid);
        return acreedor;
      });
    }
    return newList;
  };

  let selectOption = async (value, select) => {
    if (window.confirm("¿Esta seguro que deseas actualizar este elemento?")) {
      if (select === "Perfiles") {
        let form = {
          profiles: value,
          user_email: usuarioAsignado.mail,
        };

        let response = await fetch(Parametros.post + "user/profiles", {
          method: "POST",
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
          body: JSON.stringify(form),
        });

        let responseJson = await response.json();

        if (
          response.status === 200 ||
          response.status === 201 ||
          response.status === 201
        ) {
          setUpdate(!update);

          alert(responseJson.message);
        } else if (response.status === Parametros.loginTokenExcept) {
          alert(Parametros.loginTokenExceptMessage);
          history.push({
            pathname: "/",
          });
        } else {
          alert("Error al Actualizar");
        }
      }
      if (select === "Clientes") {
        let form = {
          clients: value,
          user_email: usuarioAsignado.mail,
        };
        try {
          const response = await fetch(Parametros.post + "user/clients", {
            method: "POST",
            headers: {
              Authorization: "Bearer " + usuario.key,
              Accept: "application/json",
              "Content-Type": "application/json",
              Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
            },
            body: JSON.stringify(form),
          });
          let responseJson = await response.json();
          setUpdate(!update);
          alert(responseJson.message);
        } catch (error) {
          alert("Error al Actualizar");
        }
      }
      if (select === "Unidades") {
        let form = {
          units: value,
          user_email: usuarioAsignado.mail,
        };
        try {
          const response = await fetch(Parametros.post + "user/units", {
            method: "POST",
            headers: {
              Authorization: "Bearer " + usuario.key,
              Accept: "application/json",
              "Content-Type": "application/json",
              Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
            },
            body: JSON.stringify(form),
          });
          let responseJson = await response.json();
          setUpdate(!update);
          alert(responseJson.message);
        } catch (error) {
          alert("Error al Actualizar");
        }
      }
    }
    setUpdate(!update);
  };

  return (
    <div className="App">
      <Sidebar tipo="2"></Sidebar>

      <div className="container">
        <UserTab nombre={"Configuracion de usuario"}></UserTab>
        <br></br>
        <div className="col-md-4">
          <h5 style={{ fontWeight: "bold" }}>Mail</h5>
          <p>{usuarioAsignado.mail}</p>
        </div>

        <div className="col-md-4">
          <h5 style={{ fontWeight: "bold" }}>Nombre de usuario</h5>
          <p>{usuarioAsignado.username}</p>
        </div>

        <div className="col-md-4">
          <h5 style={{ fontWeight: "bold" }}>Apellido</h5>
          <p>{usuarioAsignado.lastname}</p>
        </div>

        <div className="col-md-12">
          <h1>Perfiles</h1>
          <div className="col-md-6">Posibles</div>
          <div className="col-md-6">Actuales</div>
          <br></br>
          <DualListBox
            icons={{
              moveLeft: <span className="glyphicon glyphicon-chevron-left" />,
              moveAllLeft: [
                <span key={0} className="glyphicon glyphicon-chevron-left" />,
                <span key={1} className="glyphicon glyphicon-chevron-left" />,
              ],
              moveRight: <span className="glyphicon glyphicon-chevron-right" />,
              moveAllRight: [
                <span key={0} className="glyphicon glyphicon-chevron-right" />,
                <span key={1} className="glyphicon glyphicon-chevron-right" />,
              ],
              moveDown: <span className="fa fa-chevron-down" />,
              moveUp: <span className="fa fa-chevron-up" />,
              moveTop: <span className="fa fa-double-angle-up" />,
              moveBottom: <span className="fa fa-double-angle-down" />,
            }}
            options={opciones.map((accion) => {
              let itemNew = {
                label: accion.description,
                value: accion.profile_id,
              };

              return itemNew;
            })}
            selected={formatAccion(usuarioAsignado.profiles)}
            onChange={(value) => {
              selectOption(value, "Perfiles");
            }}
          />
          <br></br>
          <br></br>
        </div>

        <div className="col-md-12">
          <h1>Clientes</h1>
          <div className="col-md-6">Posibles</div>
          <div className="col-md-6">Actuales</div>
          <br></br>
          <DualListBox
            icons={{
              moveLeft: <span className="glyphicon glyphicon-chevron-left" />,
              moveAllLeft: [
                <span key={0} className="glyphicon glyphicon-chevron-left" />,
                <span key={1} className="glyphicon glyphicon-chevron-left" />,
              ],
              moveRight: <span className="glyphicon glyphicon-chevron-right" />,
              moveAllRight: [
                <span key={0} className="glyphicon glyphicon-chevron-right" />,
                <span key={1} className="glyphicon glyphicon-chevron-right" />,
              ],
              moveDown: <span className="fa fa-chevron-down" />,
              moveUp: <span className="fa fa-chevron-up" />,
              moveTop: <span className="fa fa-double-angle-up" />,
              moveBottom: <span className="fa fa-double-angle-down" />,
            }}
            options={clients.map((client) => {
              let itemNew = {
                label: client.name,
                value: client.client_id,
              };

              return itemNew;
            })}
            selected={usuarioAsignado?.clients?.map(
              (client) => client?.client_id
            )}
            onChange={(value) => {
              selectOption(value, "Clientes");
            }}
          />
          <br></br>
          <br></br>
        </div>

        <div className="col-md-12">
          <h1>Unidades</h1>
          <div className="col-md-6">Posibles</div>
          <div className="col-md-6">Actuales</div>
          <br></br>
          <DualListBox
            icons={{
              moveLeft: <span className="glyphicon glyphicon-chevron-left" />,
              moveAllLeft: [
                <span key={0} className="glyphicon glyphicon-chevron-left" />,
                <span key={1} className="glyphicon glyphicon-chevron-left" />,
              ],
              moveRight: <span className="glyphicon glyphicon-chevron-right" />,
              moveAllRight: [
                <span key={0} className="glyphicon glyphicon-chevron-right" />,
                <span key={1} className="glyphicon glyphicon-chevron-right" />,
              ],
              moveDown: <span className="fa fa-chevron-down" />,
              moveUp: <span className="fa fa-chevron-up" />,
              moveTop: <span className="fa fa-double-angle-up" />,
              moveBottom: <span className="fa fa-double-angle-down" />,
            }}
            options={units.map((client) => {
              let itemNew = {
                label: client.name,
                value: client.unit_id,
              };

              return itemNew;
            })}
            selected={usuarioAsignado?.units?.map((unit) => unit?.unit_id)}
            onChange={(value) => {
              selectOption(value, "Unidades");
            }}
          />
          <br></br>
          <br></br>
        </div>
      </div>

      <br></br>
      <br></br>
      <br></br>
      <br></br>
    </div>
  );
}

export default withRouter(AsignacionPerfiles);
